import { MouseEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import LoaderOverlay from "../loading_page/loading_page";
import dompurify from "dompurify";
import axios from "axios";
import download from "downloadjs";
import _, { set } from "lodash";
import "./post_detail_page.css";

type Post = {
  postType: string;
  postId: string;
};

type PostDetailFile = {
  id: string;
  name: string;
  url: string;
  address: string;
};

type PostDetail = {
  title: string;
  content: string;
  writer: string;
  view: number;
  createdAt: string;
  files: PostDetailFile[];
};

function PostDetailPage({ postType, postId }: Post) {
  const [cookie, setCookie] = useCookies(["admin"]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [writer, setWriter] = useState("");
  const [view, setView] = useState(0);
  const [createdAt, setCreatedAt] = useState("");
  const [files, setFiles] = useState<PostDetailFile[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const sanitizer = dompurify.sanitize;
  const navigate = useNavigate();
  const clean = dompurify.sanitize(content, {ADD_TAGS: ["iframe"]});

  if (postType !== "notice" && postType !== "info" && postType !== "qna")
    navigate("/noMatch");

  if (_.isEmpty(postId)) navigate("/noMatch");

  const onDeletePostBtnClicked = (event: any) => {
    const deletePostAPI = process.env.REACT_APP_SERVER_URI + "/post";

    setIsLoading(true);

    axios
      .delete(deletePostAPI, {
        params: {
          postType,
          postId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.admin,
        },
      })
      .then((res) => {
        navigate("/community/" + postType);
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteBtn = (
    <div className="delete_btn_container">
      <button className="delete_btn" onClick={onDeletePostBtnClicked}>
        삭제
      </button>
    </div>
  );

  const downloadFile = async (url: string, name: string) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error("다운로드 실패");
    const blob = await res.blob();
    download(blob, name);
  };

  useEffect(() => {
    const getDetailAPI = process.env.REACT_APP_SERVER_URI + "/post/detail";

    setIsLoading(true);

    axios
      .get(getDetailAPI, {
        params: {
          postType,
          postId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const d = res.data.foundDetail as PostDetail;
        setTitle(d.title);
        setContent(d.content); // 서버 키가 contentHtml이면 d.contentHtml
        setWriter(d.writer);
        setView(d.view);
        setCreatedAt(d.createdAt);
        setFiles(d.files);
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="post_detail_page">
      <div className="title_container">
        <div className="title">{title}</div>
      </div>
      <div className="additional_container">
        <div className="writer">작성자: {writer}</div>
        <div className="created_at">
          작성일: {new Date(createdAt).toLocaleDateString()}
        </div>
        <div className="view">조회수: {view}</div>
      </div>
      <div className="boundary_line"></div>
      <div
        className="content_container"
        dangerouslySetInnerHTML={{ __html: clean }}
      ></div>
      {_.isEmpty(files) ? (
        <></>
      ) : (
        <div className="file_download_container">
          <div className="file_container_label">첨부파일</div>
          {files.map((file) => (
            <div
              className="file_btn"
              onClick={() => {
                downloadFile(file.url, file.name);
              }}
            >
              {file.name}
            </div>
          ))}
        </div>
      )}
      {_.isEmpty(cookie) ? <></> : deleteBtn}
      <LoaderOverlay open={isLoading} text="로딩 중입니다" />
    </div>
  );
}

export default PostDetailPage;
